// extracted by mini-css-extract-plugin
module.exports = {"root":"Html_root__va6XB","reveal-media":"Html_reveal-media__ZT8qZ"};